import React from "react";
import Tooltip from "antd/lib/tooltip";

export const goalieStatsColumns = [
  {
    dataIndex: "name",
    title: "Name",
    width: 200
  },
  {
    dataIndex: "jerseyNumber",
    title: <Tooltip title="Jersey Number">#</Tooltip>
  },
  {
    dataIndex: "gamesPlayed",
    title: <Tooltip title="Games Played">GP</Tooltip>
  },
  {
    dataIndex: "wins",
    title: <Tooltip title="Wins">W</Tooltip>
  },
  {
    dataIndex: "losses",
    title: <Tooltip title="Losses">L</Tooltip>
  },
  {
    dataIndex: "ties",
    title: <Tooltip title="Ties">T</Tooltip>
  },
  {
    dataIndex: "overtimeLosses",
    title: <Tooltip title="Overtime Losses">OTL</Tooltip>
  },
  {
    dataIndex: "shotsOnGoal",
    title: <Tooltip title="Shots on Goal">SOG</Tooltip>
  },
  {
    dataIndex: "saves",
    title: <Tooltip title="Saves">S</Tooltip>
  },
  {
    dataIndex: "savePercentage",
    title: <Tooltip title="Save Percentage">SV%</Tooltip>
  },
  {
    dataIndex: "shutouts",
    title: <Tooltip title="Shutouts">SO</Tooltip>
  },
  {
    dataIndex: "goalsAgainstAverage",
    title: <Tooltip title="Goals Against Average">GAA</Tooltip>
  }
  // Apply the StatsTable class, which sets the padding to 1.
].map(c => ({ ...c, className: "StatsTable" }));
